import { useEffect, useState } from 'react';
import { parkingQueueApi } from '../../api/parkingQueueApi';
import { Lease } from '../../types/leases';
import { LeaseObjectType } from '../../types/Enums';
import { ParkingQueueEntry } from '../../types/parkingQueue';

export interface LeaseQueueMatch {
    /** The lease's active entries wanting its area; null while loading or when there is nothing to check. */
    entries: ParkingQueueEntry[] | null;
}

/**
 * After a parking lease is written outside the queue: the tenant's active
 * entries the lease may fill (`parkingQueueApi.entriesForLease`). Anything but
 * a parking-spot lease yields an empty list. A failed read is logged and
 * treated as no match, so the lease flow is never held up by the queue.
 */
export const useLeaseQueueMatch = (lease: Lease | null): LeaseQueueMatch => {
    const [entries, setEntries] = useState<ParkingQueueEntry[] | null>(null);
    const leaseKey = lease?.key;

    useEffect(() => {
        setEntries(null);
        if (!lease) return;
        const { object } = lease;
        if (object.type !== LeaseObjectType.ParkingSpot || !object.areaKey || !object.key) {
            setEntries([]);
            return;
        }
        let cancelled = false;
        parkingQueueApi.entriesForLease(lease.tenantKey, { buildingKey: lease.buildingKey, areaKey: object.areaKey })
            .then(found => { if (!cancelled) setEntries(found); })
            .catch(e => { console.error('Kunde inte läsa parkeringskön', e); if (!cancelled) setEntries([]); });
        return () => { cancelled = true; };
        // The lease is fixed for one check; its key identifies it.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leaseKey]);

    return { entries };
};
